// export const API_BASE_URL = "http://localhost:8080";
export const API_BASE_URL = "https://cce.astanait.edu.kz";
// export const CLIENT_BASE_URL = "http://localhost:3000";
export const CLIENT_BASE_URL = "https://cce.astanait.edu.kz";